export default {
  transactionAmountBaseStyle: {
    fontWeight: "600"
  },
};
